// import React from "react";

// const HowRentTwo = () => {
//   return (
//     <section className="how-rent-two section-space p-0 py-5">
//       <div className="container">
//         <div className="row gutter-y-30">

//           {/* Item 1 */}
//           <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
//             <div
//               className="how-rent-two__item wow fadeInLeft"
//               data-wow-duration="1500ms"
//               data-wow-delay="200ms"
//             >
//               <div className="how-rent-two__item__top">
//                 <div className="how-rent-two__item__icon">
//                   <i className="icon-car-1"></i>
//                 </div>
//               </div>

//               <h4 className="how-rent-two__item__title text-dark">
//                 BOOK YOUR VEHICLE
//               </h4>

//               <p className="how-rent-two__item__text  text-dark">
//                 Choose your preferred vehicle and reserve your ride with quick booking support.
//               </p>
//             </div>
//           </div>

//           {/* Item 2 */}
//           <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
//             <div
//               className="how-rent-two__item wow fadeInLeft"
//               data-wow-duration="1500ms"
//               data-wow-delay="400ms"
//             >
//               <div className="how-rent-two__item__top">
//                 <div className="how-rent-two__item__icon">
//                   <i className="icon-car-insurance"></i>
//                 </div>
//               </div>

//               <h4 className="how-rent-two__item__title text-dark">
//                 CONFIRM BOOKING
//               </h4>

//               <p className="how-rent-two__item__text  text-dark">
//                 Confirm your travel details easily with transparent pricing and instant assistance.
//               </p>
//             </div>
//           </div>

//           {/* Item 3 */}
//           <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
//             <div
//               className="how-rent-two__item wow fadeInLeft"
//               data-wow-duration="1500ms"
//               data-wow-delay="600ms"
//             >
//               <div className="how-rent-two__item__top">
//                 <div className="how-rent-two__item__icon">
//                   <i className="icon-car-insurance-1"></i>
//                 </div>
//               </div>

//               <h4 className="how-rent-two__item__title   text-dark">
//                 PICKUP & DELIVERY
//               </h4>

//               <p className="how-rent-two__item__text  text-dark">
//                 Enjoy timely pickup and smooth vehicle delivery service at your chosen location.
//               </p>
//             </div>
//           </div>

//           {/* Item 4 */}
//           <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
//             <div
//               className="how-rent-two__item wow fadeInLeft"
//               data-wow-duration="1500ms"
//               data-wow-delay="800ms"
//             >
//               <div className="how-rent-two__item__top">
//                 <div className="how-rent-two__item__icon">
//                   <i className="icon-satisfaction"></i>
//                 </div>
//               </div>

//               <h4 className="how-rent-two__item__title  text-dark">
//                 ENJOY YOUR JOURNEY
//               </h4>

//               <p className="how-rent-two__item__text text-dark">
//                 Travel safely and comfortably with clean vehicles and professional drivers always.
//               </p>
//             </div>
//           </div>

//         </div>
//       </div>

//       {/* Decorative Images */}
//       {/* 
//       <div className="how-rent-two__element-one">
//         <img
//           src="assets/images/resources/how-1-1.png"
//           alt="Element One"
//         />
//       </div>

//       <div className="how-rent-two__element-two">
//         <img
//           src="assets/images/resources/how-1-2.png"
//           alt="Element Two"
//         />
//       </div> 
//       */}
//     </section>
//   );
// };

// export default HowRentTwo;










import React from "react";

const HowRentTwo = () => {
  return (
    <section className="how-rent-two section-space p-0 py-5">
      <div className="container">
        <div className="row gutter-y-30">

          {/* Item 1 */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div
              className="how-rent-two__item wow fadeInLeft"
              data-wow-duration="1500ms"
              data-wow-delay="200ms"
            >
              <div className="how-rent-two__item__top">
                <div className="how-rent-two__item__icon">
                  <i className="icon-car-1"></i>
                </div>
              </div>

              <h4 className="how-rent-two__item__title text-dark">
                CHOOSE YOUR BUS
              </h4>

              <p className="how-rent-two__item__text text-dark">
                Browse our fleet and select the ideal bus for your travel
                requirements and group size.
              </p>
            </div>
          </div>

          {/* Item 2 */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div
              className="how-rent-two__item wow fadeInLeft"
              data-wow-duration="1500ms"
              data-wow-delay="400ms"
            >
              <div className="how-rent-two__item__top">
                <div className="how-rent-two__item__icon">
                  <i className="icon-car-insurance"></i>
                </div>
              </div>

              <h4 className="how-rent-two__item__title text-dark">
                REQUEST A QUOTE
              </h4>

              <p className="how-rent-two__item__text text-dark">
                Share your journey details and receive a competitive quotation
                with complete pricing transparency.
              </p>
            </div>
          </div>

          {/* Item 3 */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div
              className="how-rent-two__item wow fadeInLeft"
              data-wow-duration="1500ms"
              data-wow-delay="600ms"
            >
              <div className="how-rent-two__item__top">
                <div className="how-rent-two__item__icon">
                  <i className="icon-car-insurance-1"></i>
                </div>
              </div>

              <h4 className="how-rent-two__item__title text-dark">
                CONFIRM BOOKING
              </h4>

              <p className="how-rent-two__item__text text-dark">
                Complete your reservation easily with dedicated support and
                flexible travel arrangements.
              </p>
            </div>
          </div>

          {/* Item 4 */}
          <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12">
            <div
              className="how-rent-two__item wow fadeInLeft"
              data-wow-duration="1500ms"
              data-wow-delay="800ms"
            >
              <div className="how-rent-two__item__top">
                <div className="how-rent-two__item__icon">
                  <i className="icon-satisfaction"></i>
                </div>
              </div>

              <h4 className="how-rent-two__item__title text-dark">
                TRAVEL COMFORTABLY
              </h4>

              <p className="how-rent-two__item__text text-dark">
                Enjoy a safe and comfortable journey with professional drivers
                and quality service.
              </p>
            </div>
          </div>

        </div>
      </div>

      {/* Decorative Images */}
      {/*
      <div className="how-rent-two__element-one">
        <img
          src="assets/images/resources/how-1-1.png"
          alt="Element One"
        />
      </div>

      <div className="how-rent-two__element-two">
        <img
          src="assets/images/resources/how-1-2.png"
          alt="Element Two"
        />
      </div>
      */}
    </section>
  );
};

export default HowRentTwo;